import React from "react";
import WorkCard from "../../../components/WorkCard";
import styles from "./style.module.scss";
import work1 from "../../../../static/car.jpeg";
import work2 from "../../../../static/game.jpeg";
import work3 from "../../../../static/medical.jpg";
import FeedIn from "../../../components/FramerMotion/FeedIn";

const Work = () => {
  return (
    <div className={styles.section} id="work">
      <FeedIn>
        <div className={styles.sectionInner}>
          <div className={styles.textArea}>
            <p className={styles.subTitle}>Work</p>
            <h3 className={styles.title}>事業について</h3>
            <p className={styles.description}>
              電気機器部品、自動車部品、医療機器部品、アミューズメント機器ユニット品、鉄道関連部品など業種問わず、さまざまな分野の製品制作に取り組んでいます。
            </p>
          </div>
          <div className={styles.cards}>
            <div className={styles.cardWrapper}>
              <WorkCard
                imageUrl={work1}
                title="自動車部品"
                description="多種成形部品に加えて縦型射出成形機によるインサート成形部品にも対応しています。"
              />
            </div>
            <div className={styles.cardWrapper}>
              <WorkCard
                imageUrl={work2}
                title="アミューズメント機器部品"
                description="流行と共に次々と変わる機種、人々が直接触れることを考慮し安全性を第一に生産しています。"
              />
            </div>
            <div className={styles.cardWrapper}>
              <WorkCard
                imageUrl={work3}
                title="医療機器部品"
                description="機器内部の部品から外装品まで、人命に関わる製品として安心をお届けしています。"
              />
            </div>
          </div>
        </div>
      </FeedIn>
    </div>
  );
};

export default Work;
